<template>
	<div>
		<a class="hover-link" style="float:left;color:white;font-size: 14px;margin-right:20px;" @click="showModalTemp()">Pay now</a>
		<modal name="creditors-payment-form" :scrollable="true" @before-open="beforeOpen" height="auto" :minHeight="600" width="1100">
			
				<div class="" id="expenseModal" role="dialog">
					<div class="">
						<!-- Modal content-->
						<expensepayment-form :building-id="buildingId"></expensepayment-form>			  			 					
					</div>
            </div>
		</modal>
	</div>
</template>
<script>
    export default {
		props : ['buildingId'],
        data: function () {
  return {
	}
},
        mounted() {
                //alert(this.buildingId);
        },
        
        methods: {
            beforeOpen (event) {
                
 },
        showModal() {
        this.isModalVisible = true;
        
      },
      closeModal() {
        this.isModalVisible = false;
      },
					fetchStatement: function(){
						
					
					
					},
                    showModalTemp: function(){
                            this.$modal.show('creditors-payment-form');
                        //alert("Id " + expenseId + " month " + month);
                        //this.isModalVisible = true;
                        
                    },
        show () {
    this.$modal.show('creditors-payment-form');
  },
  hide () {
    this.$modal.hide('creditors-payment-form');
  },

            /**
             * Prepare the component.
             */
            
            },
			
			computed : {
			total: function(){
				return this.expenseFees[0].reduce(function(total, fees){

                return total + fees[0]; 
				},0);
        },
			}

	}                // Our Javascript logic
    
    
</script>